import React from "react";
import Navbar from "../../components/common/navbar/Navbar";
import Herobanner from "./carousel/Herobanner";
import Studenttools from "./studentTools/StudentTools";
import Footer from "../../components/common/Footer/Footer";

const Landing = () => {

    return(
       <div>
            <Navbar />
            <Herobanner />
            <Studenttools />
            <Footer />
        </div>
    )
}

export default Landing;